import { StepDef, TestDef } from "../models.js";
import { testSetup, ensureBrakesUnlocked, hasCoveredMinDistance } from "./commonSteps.js";
import { configCheckerOnErrorCallback } from "../configChecker_helpers";
import { checkIsSensorTriggered, moveAwayFromSensor, diagnoseBadSensor } from "./commonSensorSteps.js";
import immediateApi from "../../../api/immediateApi";


const before = new StepDef( ({ runtime, actuator }) => {
  runtime.ctx.sensorName = 'end';
  runtime.ctx.validatable = actuator.endSensorValidatable;
  runtime.ctx.direction = 1;
  runtime.ctx.movedAwayFromSensor = false;
  runtime.ctx.movedTowardsSensor = false;
  runtime.runStep(testSetup(checkIsSensorTriggered(checkAfterMove)));
});

const checkAfterMove = new StepDef(({ runtime, notifier, actuator, pass, diagnose }) => {

  if (runtime.ctx.triggeredEndStop) {
    // Note : The end sensor test should never try to run autoFixSensors
    immediateApi.getEndstopConfig(actuator.parameters.controllerId, runtime.ctx.triggeredDriveNumber)
      .then((pEndStopConfig) => {
        diagnose({
          error: "The motion triggered a sensor on another actuator.",
          resolution: {
            description: [
              `Swap the wiring of the sensors connected to:`,
              `  • DRIVE ${actuator.driveNumber}'s motor SENSOR ${actuator.endport} port`,
              `  • DRIVE ${runtime.ctx.triggeredDriveNumber}'s motor SENSOR ${pEndStopConfig[runtime.ctx.triggeredEndStop]} port.`
            ],
          },
          tooltips: [{category: 'sensor'}, {category: 'sensorPort'}],
          errorCode: -1,
        });
        runtime.ctx.triggeredEndStop = undefined; //reset
        runtime.ctx.triggeredDriveNumber = undefined; //reset
        notifier.finished();
      }).catch(configCheckerOnErrorCallback);
  }
  else if (runtime.ctx.movedAwayFromSensor) {
    runtime.runStep(diagnoseBadSensor);
  }
  else {
    hasCoveredMinDistance(runtime, actuator, () => {
      if (runtime.ctx.actuatorDidntMove) {
        runtime.ctx.doNotPromptUserForConsent = true;
        runtime.runStep(ensureBrakesUnlocked(moveAwayFromSensor(checkAfterMove)));
      }
      else {
        runtime.runStep(diagnoseBadSensor);
      }
    });
  }
});


// definition could dynamically be based on actuator, so DI the actuator instance, and the def is based on it (no need for getValidations)
export default new TestDef({
  info: {
    friendlyName: "Verify the end sensor",
    precedence: 4,
    desc: 'To verify that the end sensor is correctly wired and mechanically installed, we will try to move the actuator to the end sensor.',
  },
  entryStep: before,
  validatesOnSuccess: (actuator) => actuator.endSensorValidatable,
  devalidatesOnFail: (actuator) => [actuator.homeSensorValidatable],
});
